/* eslint-disable no-param-reassign */
import { h, render } from 'preact';
import ProductGrid from './product-grid';
import './product-grid.css';

export default (element, data) => {
  const init = () => {
    render(<ProductGrid {...data} />, element);
  };

  init();
};
